import {Action} from '@ngrx/store';
import {TreeNavigationConfiguration} from "@ispm-client/modules/process-executor/models/tree-navigation-configuration";

export enum BpmnDisplayActionsTypes {
  UPDATE_NODES_NAMES = '[Bpmn Process] Update Nodes Names',
  UPDATE_TREE_NAVIGATION_CONF = '[Bpmn Process] Update Tree Navigation Conf'
}

export class UpdateNodesNamesAction implements Action {
  readonly type = BpmnDisplayActionsTypes.UPDATE_NODES_NAMES;
  constructor(public payload: { nodeIdToNameSuffixDictionary: any}) { }
}

export class UpdateTreeNavigationConfAction implements Action{
  readonly type = BpmnDisplayActionsTypes.UPDATE_TREE_NAVIGATION_CONF;
  constructor(public payload: {treeNavigationConf: TreeNavigationConfiguration}) {}
}

export type BpmnDisplayActions = UpdateNodesNamesAction | UpdateTreeNavigationConfAction;
